import { INoEditService } from '@src/slide/application/no-edit/service/no-edit-service/no-edit-service.interface';
import { IBaseEditorExtensionService } from '@src/slide/application/service/edit-extension/core/editor/base/interface';
import { IEventEmitter } from '@src/slide/infrastructure/module/independent/event-emitter/event-emitter.interface';
import { AuthEventsMap } from '@src/slide/application/no-edit/plugins/auth/base/auth-events.interface';

export enum AuthType {
    Self = 0, // 私密
    Cooperation = 1, // 指定人
    Viewable = 2, // 所有人可查看
    Editable = 3, // 所有人可编辑
}

export enum SAFE_FOLDER_MOVE_EVENT {
    MOVE_TO_SAFE = 'move_to_safe',          // MoveToSafe 移动到加密文件夹
    SAFE_TO_PRIVATE = 'safe_to_private',    // SafeToPrivate 移出加密文件夹
}

export interface IAuth {
    // 事件通知
    event: IEventEmitter<AuthEventsMap>;
    policy: AuthType;
    info: any;
    /**
     * 权限是否过期
     */
    isAuthExpired(): boolean;

    /**
     * 过期时间更新
     * @param exptime
     * @param remaintime
     * @param settime
     * @param starttime
     */
    setAuthExpInfo(exptime: number, remaintime: number, settime: number, starttime: number);
    setAuthInfo(info);
}

export type AuthProps = {
    noEditService?: INoEditService,
    editExtensionService?: IBaseEditorExtensionService,
};
